export const OUTGOING = 'OUTGOING';
export const INCOMING = 'INCOMING';